$(function() {
  blog_figs = document.querySelectorAll('action-text-attachment figure');
  blog_figs.forEach(function(fig) {
    img = fig.querySelector('img')
    img.setAttribute('alt', fig.querySelector('figcaption').textContent.trim());
    img.setAttribute('title', fig.querySelector('figcaption').textContent.trim());
    fig.querySelector('figcaption').remove();
  });
});